// import React from "react";

// const images = [
//   "./Clients/ArmstrongLogo.png",
//   "./Clients/BannariAmmanLogo.png",
//   "./Clients/classicPoloLogo.png",
//   "./Clients/CrystalLogo.png",
//   "./Clients/DollarLogo.png",
//   "./Clients/EastmanLogo.png",
//   "./Clients/KPRLogo.png",
//   "./Clients/PoppysLogo.png",
//   "./Clients/RupaLogo.png",
// ];

// const Marquee = () => {
//   return (
//     <div
//       style={{
//         width: "100%",
//         overflow: "hidden",
//         position: "relative",
//         whiteSpace: "nowrap",
//         height: "100px", // Adjust based on your actual height requirements
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           animation: "scroll-left 20s linear infinite",
//         }}
//       >
//         {/* Double the array for seamless looping */}
//         {images.concat(images).map((image, index) => (
//           <img
//             key={index}
//             src={image}
//             alt={`Client logo ${index}`}
//             style={{
//               height: "96px", // Ensure all images are the same size
//               width: "96px", // Ensure all images are the same size
//               objectFit: "contain",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Marquee;

import React from "react";
import Marquee from "react-fast-marquee";

const images = [
  "./Clients/ArmstrongLogo.png",
  "./Clients/BannariAmmanLogo.png",
  "./Clients/classicPoloLogo.png",
  "./Clients/CrystalLogo.png",
  "./Clients/DollarLogo.png",
  "./Clients/EastmanLogo.png",
  "./Clients/KPRLogo.png",
  "./Clients/PoppysLogo.png",
  "./Clients/RupaLogo.png",
];

const MarqueeDemo = () => {
  return (
    <Marquee speed={50} gradient={false} pauseOnHover={true}>
      <div style={{ display: "flex" }}>
        {/* Map through images twice for continuous effect */}
        {images.concat(images).map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Client Logo ${index}`}
            style={{
              width: "140px",
              height: "70px",
              marginRight: "20px",
              marginLeft: "20px",
            }}
          />
        ))}
      </div>
    </Marquee>
  );
};

export default MarqueeDemo;
